import React, { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';
import { Address, Contact, Copy, Customer, CustomerInfo, EmailBox, Phone, Shipping, ShippingID, ShippingMethod } from '../../../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {

    MenuItem,
    Menu,
    Button,
    Paper,
    Typography,
    Box,
    Divider, Grid,
    Chip
} from "@mui/material";
import { ArrowDropDown, Close, Opacity, Refresh } from '@mui/icons-material';
import styless from './order.module.css';
import { getMatchedProductsThunk } from '../../../../Website/redux/bomSlice';
import { formatDate } from 'react-calendar/dist/cjs/shared/dateFormatter.js';
import { exportDataExcel, handleCopy } from '../../../../Website/utils/utils';
import { toast } from 'react-toastify';
import api from '../../../../Website/utils/api';
import BomListTable from '../../Components/BomListTable/BomListTable';
import { getRecievedOrderDetailsThunk } from '../../../../Website/redux/receivedVendorOrderSlice';
import Myprofile from '../myprofile/Myprofile';


const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));


const New = styled(Chip)(({ theme }) => ({
    backgroundColor: '#4A4C561A',
    color: '#4A4C56',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Processing = styled(Chip)(({ theme }) => ({
    backgroundColor: '#FFF0EA',
    color: '#F86624',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));


const Cancelled = styled(Chip)(({ theme }) => ({
    backgroundColor: '#FFF0EA',
    color: 'red',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
    backgroundColor: '#EAF8FF',
    color: '#2BB2FE',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
    backgroundColor: '#E9FAF7',
    color: '#1A9882',
    fontWeight: 'bold',
    borderRadius: '4px',
    lineHeight: '24px',
    fontSize: '14px',
    fontFamily: `'Public Sans', sans-serif !important`,
}));


const ActionCancelButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    backgroundColor: '#F0F1F3',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    borderRadius: '8px',
    '&:hover': {
        backgroundColor: '#F43224',
    },
}));


const status = [
    "NEW", "PROCESSING", "PENDING", "SHIPPED", "DELIVERED"
]

const ReceivedOrderDetails = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [cancelModal, setCancelModal] = useState(false)
    const open = Boolean(anchorEl);
    const { macthedProducts, suppliers } = useSelector((state) => state.bom)
    const [showSupplier, setShowSupplier] = useState(false)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const { loading, refresh, orderDetails } = useSelector((state) => state.receivedOrders);

    console.log(orderDetails);


    const dispatch = useDispatch()
    const { id } = useParams()




    useEffect(() => {
        const productData = [{
            productNumber: orderDetails?.partList?.productNumber,
            quantity: orderDetails?.partList?.quantity
        }]
        dispatch(getMatchedProductsThunk(productData))
    }, [orderDetails])

    useEffect(() => {
        dispatch(getRecievedOrderDetailsThunk(id))
    }, [refresh])

    const handleClose = (status) => {
        if (status) {
            changeStatus(status)
        }
        setAnchorEl(null);
    };




    const changeStatus = async (status) => {
        const datas = {
            id: id,
            status: status
        }
        try {
            const { data } = await api.updatebomOrderStatus(datas)
            if (data) {
                toast.success('Status updated succesfully')
                // dispatch(setbomOrderrefresh())
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || 'something went wrong')
        } finally {
            setCancelModal(false)
        }
    }


    const exportOrderDetails = async () => {

        const exportdata = {
            'id': orderDetails?._id || '-',
            'customer Name': orderDetails?.userId?.fullName || '-',
            'Customer Email': orderDetails?.userId?.email || '-',
            'productNumbers': orderDetails.products
                .flatMap((product) =>
                    product.productDetails?.productOverview?.productNumber || []
                )
                .join(", "),
            'Sub Total': orderDetails?.priceBreakup?.subTotal || '-',
            'Tax': orderDetails?.priceBreakup?.tax || '-',
            'Other Charges': orderDetails?.priceBreakup?.otherCharges || '-',
            'Total': orderDetails?.priceBreakup?.total || '-',
            'Status': orderDetails?.status || '-',
            'CreatedAt': formatDate(orderDetails?.createdAt)
        }

        exportDataExcel([exportdata], "ordersdetails")
    }


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Loading....
            </div>
        )
    }

    return (
        <Myprofile>

            {/* <UserHeader
                index={`Order #${orderDetails?._id}`}
                root="Dashboard"
                buttonText={'Add Vendor'}
                showHeader={'orderDetails'}
                exportData={exportOrderDetails}
            /> */}
            <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
                <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
                    <div style={{ display: 'flex' }}>
                        <Typography
                            sx={{
                                color: 'rgba(29, 31, 44, 1)',
                                fontSize: '20px',
                                fontWeight: '600',
                                fontFamily: `'Public Sans', sans-serif`,
                            }}>
                            Order #{orderDetails?._id}
                        </Typography>
                        <Typography style={{
                            marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
                            color: '#01A1FE',
                            background: "#EFF9FF",

                        }}>
                            {orderDetails?.status === "NEW" ? (
                                <New label="New" size="small" />
                            ) : orderDetails?.status === "DELIVERED" ? (
                                <Delivered label="Delivered" size="small" />
                            ) : orderDetails?.status === "PROCESSING" ? (
                                <Processing label="Processing" size="small" />
                            ) : orderDetails?.status === "CANCELLED" ? (
                                <Cancelled label="Cancelled" size="small" />
                            ) : (
                                <Shiped label="shipped" size="small" />
                            )}
                        </Typography>
                    </div>
                    <div>

                        <ActionCancelButton
                            sx={{
                                color: '#fff',
                                border: '1px solid #F43224',
                                background: '#F43224',
                                borderRadius: '8px',
                            }}
                            onClick={() => setCancelModal(!cancelModal)}
                        >Cancel order
                        </ActionCancelButton>

                        <ActionButton
                            onClick={handleClick}
                            sx={{
                                color: '#667085',
                                border: '1px solid #E0E2E7',
                                background: '#fff',
                                borderRadius: '8px',
                            }}
                        >
                            Status
                            <ArrowDropDown />
                        </ActionButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={() => handleClose('')}
                            MenuListProps={{
                                'aria-labelledby': 'status-button',
                            }}
                        >
                            {
                                status?.map((i) => (
                                    <MenuItem onClick={() => handleClose(i)}
                                        sx={{
                                            borderBottom: '1px solid #E6E1E5',
                                            fontSize: '14px',
                                            color: '#667085',
                                            textTransform: 'capitalize'
                                        }}>
                                        {i}
                                    </MenuItem>
                                ))
                            }


                        </Menu>
                    </div>
                </div>

                {loading ? <div>Please wait...</div> :
                    <Box maxWidth="lg">

                        <Grid container spacing={3}>
                            {/* <Grid item xs={12} md={6}>
                                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <CustomerInfo />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Customer Info
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: 3, }} display="flex" alignItems="flex-start" >
                                        <Customer />
                                        <Box style={{ marginLeft: '8px', }}>
                                            <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                Customer
                                            </Typography>
                                            <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                {orderDetails?.userId?.fullName}
                                            </Typography></Box>
                                    </Box>
                                </Paper>
                            </Grid> */}


                            {/* <Grid item xs={12} md={6}>
                                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <Contact />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Contact
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <EmailBox />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Email
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.userId?.email}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.userId?.email)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <Phone />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Phone Number
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.userId?.phone}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.userId?.phone)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid> */}


                            <Grid item xs={12} md={6}>
                                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <Shipping />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Shipping
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <ShippingID />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Shipping ID
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    SHP1092311<br />
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div >
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <ShippingMethod />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Shipping Method
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    Regular
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <Address />
                                            <Box style={{ marginLeft: '8px', }}>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                                                    Shipping Address
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>

                                                    {orderDetails?.shippingAddress?.factoryUnits}<br />
                                                    {orderDetails?.shippingAddress?.streetAddress}, {orderDetails?.shippingAddress?.state} - {orderDetails?.shippingAddress?.zipCode},{orderDetails?.shippingAddress?.country}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>

                        {/* <BomQuote /> */}
                        <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
                            <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
                                <Box display="flex" alignItems="center" >
                                    <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
                                        1 Products
                                    </Typography>
                                    <Typography style={{ margin: '6px' }}>•</Typography>
                                    {/* <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', color: '#4D4D4D' }}>
                                        Quoted date: {formatDate(orderDetails?.createdAt)}
                                    </Typography> */}
                                    <Typography style={{ margin: '6px' }}>•</Typography>
                                    <Typography style={{ padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", color: orderDetails?.status === "NEW" ? "#4A4C56" : orderDetails?.status === "QUOTED" ? "#00B789" : "#1A9882" }}>
                                        {orderDetails?.status}
                                    </Typography>

                                </Box>

                            </Box>
                            <div style={{ display: 'flex', gap: "20px" }}>
                                <div style={{ width: '100%' }}>

                                    <BomListTable
                                        products={macthedProducts}
                                        show={true}
                                    />


                                </div>
                                <div style={{ width: '70%', marginTop: "20px" }}>
                                    <table className={styless.productTable22}>
                                        <thead className={styless.productTableHead22}>
                                            <tr>
                                                <th className={styless.partNumber}>Quote price</th>
                                                <th className={styless.partNumber}>MOQ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={{ height: 100 }}>
                                                <td className={`${styless.requiredQuantity} ${styless.tdBorder}`}>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter"
                                                        className={styless.dataInput}
                                                        style={{ width: "80%" }}
                                                        value={orderDetails?.partList?.quotePrice || ""} // Default empty if not present
                                                        disabled={true}
                                                    />
                                                </td>
                                                <td className={`${styless.requiredQuantity} ${styless.tdBorder}`}>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter"
                                                        className={styless.dataInput}
                                                        style={{ width: "80%" }}
                                                        value={orderDetails?.partList?.moq || ""} // Default empty if not present
                                                        disabled={true}
                                                    />
                                                </td>


                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </Paper>

                        <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "8px", marginTop: "26px" }}>
                            <Box sx={{ p: 2, }} display="flex" justifyContent="space-between" >
                                <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
                                    Grand Total :
                                </Typography>
                                <Typography style={{ marginRight: '10px', fontSize: '18px', fontWeight: "600", }}>
                                    {orderDetails?.total || 0}
                                </Typography>
                            </Box>
                        </Paper>
                        {/* <CancelModal
                            onDelete={() => changeStatus('CANCELLED')}
                            isOpen={cancelModal}
                            onClose={() => setCancelModal(false)}
                        /> */}

                    </Box>
                }
            </div>
        </Myprofile>
    );
};

export default ReceivedOrderDetails;
